import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "custom-notification__icon" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "custom-notification__title"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'background-dark': _ctx.$route.name == 'NewOrder' || _ctx.$route.path == '/login',
    })
  }, [
    _createVNode(_component_DefaultLayout, null, {
      default: _withCtx(() => [
        _createVNode(_component_notifications, {
          position: "top center",
          width: "320"
        }, {
          body: _withCtx(({ item }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["custom-notification", `custom-notification--${item.type}`])
            }, [
              _hoisted_1,
              (item.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "custom-notification__text",
                innerHTML: item.text
              }, null, 8, _hoisted_3),
              (item.data.click)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "custom-notification__cta",
                    onClick: item.data.click
                  }, " OK ", 8, _hoisted_4))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
              key: 0,
              full: true
            }))
          : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      ]),
      _: 1
    })
  ], 2))
}